var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoConverterDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "23px",
    viewBox: "0 0 36 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-925.000000, -1212.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(926.000000, 1213.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(7.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,13 C1,14.6568542 4.80557963,16 9.5,16 C14.1944204,16 18,14.6568542 18,13",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,18 C1,19.6568542 4.80557963,21 9.5,21 C14.1944204,21 18,19.6568542 18,18",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,8 C1,9.65685425 4.80557963,11 9.5,11 C14.1944204,11 18,9.65685425 18,8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    cx: 9.5,
    cy: 3,
    rx: 8.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,3 L1,18",
    id: "Path-102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,3 L18,18",
    id: "Path-102"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-103",
    points: "28.3061523 8 33.9594727 8 33.9594727 16.5 29.5668945 16.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-103",
    transform: "translate(2.826660, 12.250000) scale(-1, -1) translate(-2.826660, -12.250000) ",
    points: "0 8 5.65332031 8 5.65332031 16.5 1.08813477 16.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-104",
    points: "31.6328125 13.3918457 28.5246582 16.5 31.6328125 19.6081543"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-104",
    transform: "translate(4.054077, 8.000000) scale(-1, 1) translate(-4.054077, -8.000000) ",
    points: "5.6081543 4.8918457 2.5 8 5.6081543 11.1081543"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConverterDatabase);
export default __webpack_public_path__ + "static/media/ico_converter-database.e1066e2719e6c2eef38cdfad96a67aee.svg";
export { ForwardRef as ReactComponent };